import { Calendar } from 'lucide-react';
import type { NewsItem } from '../../types';
import { Link } from 'react-router-dom';

interface NewsCardProps {
  news: NewsItem;
}

export function NewsCard({ news }: NewsCardProps) {
  const formattedDate = new Date(news.created_at).toLocaleDateString('no-NO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <Link to={`/news/${news.slug}`}>
        <img 
          src={news.imageUrl || '/images/f-image-molde.png'} 
          alt={news.title} 
          className="w-full h-48 object-cover transition-transform hover:scale-105"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = '/images/f-image-molde.png';
          }}
        />
      </Link>
      <div className="p-6">
        <div className="flex items-center gap-2 mb-2">
          <Calendar className="w-4 h-4 text-[#2173B9]" />
          <span className="text-sm text-gray-600">{formattedDate}</span>
        </div>
        <Link 
          to={`/news/${news.slug}`}
          className="group"
        >
          <h3 className="text-xl font-semibold mb-4 group-hover:text-[#2173B9] transition-colors">
            {news.title}
          </h3>
        </Link>
        <Link 
          to={`/news/${news.slug}`} 
          className="inline-block text-[#2173B9] hover:underline"
        >
          Read more
        </Link>
      </div>
    </div>
  );
}
